import styled from "styled-components";
import { themeColor } from "ui/theme";
import { getMessagesUnreadCountByUser } from "services/firestore/getMessagesUnreadCountByUser";
import { useEffect, useState } from "react";
import { doc, onSnapshot } from "firebase/firestore";
import firestore from "services/firestore";

export function UnreadBadge({ msg, currentUserId, onLastMessageUpdate }) {
  if (!msg.lastMessage || !msg.firestore_conversation_id) return null;

  const [count, setCount] = useState(0);
  const [lastMessage, setLastMessage] = useState(msg.lastMessage);

  useEffect(() => {
    const unsubscribeCount = getMessagesUnreadCountByUser(
      currentUserId,
      msg.firestore_conversation_id,
      setCount
    );

    const conversationRef = doc(
      firestore,
      "conversations",
      msg.firestore_conversation_id
    );
    const unsubscribeLastMessage = onSnapshot(
      conversationRef,
      (docSnapshot) => {
        if (docSnapshot.exists()) {
          const conversationData = docSnapshot.data();
          if (conversationData.lastMessage !== lastMessage) {
            setLastMessage(conversationData.lastMessage);
            msg.lastMessage = conversationData.lastMessage;
            if (onLastMessageUpdate) {
              onLastMessageUpdate(conversationData.lastMessage);
            }
          }
        }
      }
    );

    return () => {
      unsubscribeCount();
      unsubscribeLastMessage();
    };
  }, [
    msg.firestore_conversation_id,
    currentUserId,
    lastMessage,
    onLastMessageUpdate,
  ]);

  if (!count) {
    return null;
  }

  return <UnreadBadgeStyled>{count}</UnreadBadgeStyled>;
}

const UnreadBadgeStyled = styled.div`
  min-width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: ${themeColor("red")};
  color: ${themeColor("white")};
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.75rem;
  font-weight: 600;
`;
